module.exports = __webpack_public_path__ + "img/green_087.05d69de2.png";